import React from 'react';
import { FormatterUtils } from '../utils/javascriptUtils';
var moment = require('moment');

function UserProductStatus(user_product) {
  const now = moment();
  const expired = moment(user_product.expired);
  const duration = Math.round(expired.diff(now, "days", true));
  return(
    <React.Fragment>
      {user_product.status === "RUNNING" && duration > 30 && <span className="badge badge-primary">ĐANG SỬ DỤNG</span>}
      {user_product.status === "RUNNING" && duration > 0 && duration <= 30 && <span className="badge badge-info">CÒN {Math.round(duration)} NGÀY HẾT HẠN</span>}
      {user_product.status === "RUNNING" && duration < 0 && <span className="badge badge-danger">HẾT HẠN</span>}
      {user_product.status === "RUNNING" && duration == 0 && <span className="badge badge-warning">HẾT HẠN TRONG HÔM NAY</span>}
      {user_product.status === "PENDING" && <span className="badge bg-purple">PENDING</span>}
      {user_product.status === "EXPIRED" && <span className="badge badge-danger">
        HẾT HẠN VÀ SUSPENDED
        <br/>
        <small>Ngày: {moment(user_product.suspend_date).format("DD-MM-YYYY")}</small>
      </span>}
      {user_product.status === "SUSPEND" && <span className="badge badge-danger">SUSPENDED
        <br/>
        <small>Ngày: {moment(user_product.suspend_date).format("DD-MM-YYYY")}</small></span>
      }
      {user_product.status === "DELETED" && <span className="badge badge-danger">ĐÃ XOÁ</span>}
      {user_product.status === "PENDING_TRANSFER" && <span style={{color: "white", background: "#999999"}} className="badge">PENDING TRANSFER</span>}
    </React.Fragment>
  )
}


export default UserProductStatus;